import Layout from "../Layout"

const Loading = () => (
  <Layout>
    <div
      css={{
        borderRadius: "8px",
        background: "rgba(0, 0, 0, 0.20)",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        color: "gray",
        fontSize: 16,
        borderRadius: 8,
        width: 256,
        height: 196,
      }}
    >
      Loading...
    </div>
  </Layout>
)

export default Loading
